
import React from 'react';
import { Popup } from "../onboarding-shared/popup";

const popup_text = "Assets in these community property states are";
const popup_text_1 = "owned by both spouses equally (50/50).";

const renderPopup = () => {
  return (
    <Popup translate_y={"-4rem"}>
      <div>{popup_text}</div>
      <div>{popup_text_1}</div>
    </Popup>
  );
};

export { renderPopup };
